





































import { defineComponent, ref, onMounted } from '@vue/composition-api'
import { currentPage } from '@/assets/page'
import { project } from '@/assets/project'
import { currentNode } from '@/assets/node'
import Render from './render/index.vue'
import { isEdit, setRenderEdit, setRenderPreview } from '@/assets/render'
import { Message } from 'element-ui'
import EditWrap from './edit-wrap.vue'
import ContextMenu from './context-menu/index.vue'

export default defineComponent({
  components: {
    Render,
    EditWrap,
    ContextMenu
  },

  setup (p, ctx) {
    const containerEl = ref(null)
    onMounted(() => {
      // @ts-ignore
      containerEl.value = ctx.refs.scrollContainer
    })
    const handleMode = () => {
      if (isEdit()) {
        setRenderPreview()
      } else {
        setRenderEdit()
      }
    }
    const handlePreviewPage = () => {
      if (currentPage.value && project.dir) {
        window.open(currentPage.value.url)
      } else {
        Message.error('项目英文名称必填')
      }
    }
    return {
      project,
      currentPage,
      currentNode,
      isEdit,
      handleMode,
      handlePreviewPage,
      handleGetContainerScrollTop () {
        if (containerEl.value) {
          return (containerEl.value! as Element).scrollTop
        }
        // console.log('handleGetContainerScrollTop 0')
        return 0
      }
    }
  }
})
